import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/WebcastDbosTransactTypescript2Page.head';
import { WebcastDbosTransactTypescript2Page } from '@pages/WebcastDbosTransactTypescript2Page';

export const Route = createFileRoute('/webcast-dbos-transact-typescript-2')({
  component: WebcastDbosTransactTypescript2Page,
  head: () => head,
});
